import { IEnvironment } from '../models';
import { environment } from './environment';

export const environmentItg: IEnvironment = {
  ...environment,
  production: false,
  envName: 'integration',
  // Session telemetry runs on integration only -- never production, sandbox,
  // staging, hotfix or local. ART-19930
  sessionTelemetryEnabled: true,
};
